import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';


export default function TrackingTable({ rows, columns, opctionsRows }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  return (
    <Paper sx={{ width: '100%', height: { xs: '90%', sm: '92%' } , overflow: 'hidden', mb: 0 }}>
      <TableContainer sx={{ maxHeight: '90%' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  sx={{ fontSize: { xs: 10, sm: 12 }, textTransform:'uppercase', lineHeight:1, textAlign: 'center', p: 1.5, display:column.display}}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code} sx={{ background: index % 2 === 0 ? '#fafafa' : '#fff' }}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        const filter = opctionsRows.find(item => item.columId === column.id)
                        return (
                          <TableCell sx={{ p: 1, fontSize: { xs: 10, sm: 12 }, textAlign: 'center',  display:column.display }} key={column.id} align={column.align}>
                            {filter && filter !== undefined
                              ? filter.component(row)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );

              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{ display: 'flex' }}
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}